import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { JobNotificationCardComponent } from '../job-notification-card.component';
import { DocoonInboundFlowNotificationCardModel } from './docoon-inbound-flow-notification-card.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-docoon-inbound-flow-notification-card',
  styleUrls: ['./docoon-inbound-flow-notification-card.component.scss'],
  templateUrl: './docoon-inbound-flow-notification-card.component.html',
  imports: [JobNotificationCardComponent, MatIcon, MatIconButton, MatTooltip],
})
export class DocoonInboundFlowNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Input({ required: true }) public docoonInboundFlowNotificationCard!: DocoonInboundFlowNotificationCardModel;
  @Output() public previewPurchaseCreditsButtonEvent = new EventEmitter<void>();
  @Output() public previewPurchaseInvoicesButtonEvent = new EventEmitter<void>();

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }

  public previewPurchaseCreditsButtonClickedHandler(): void {
    this.previewPurchaseCreditsButtonEvent.emit();
  }

  public previewPurchaseInvoicesButtonClickedHandler(): void {
    this.previewPurchaseInvoicesButtonEvent.emit();
  }
}
